var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_005-medical_app",
    "data-name": "005-medical app",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.734,
    height: 45.658,
    viewBox: "0 0 53.734 45.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7055",
    "data-name": "Group 7055",
    transform: "translate(11.743 14.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7054",
    "data-name": "Group 7054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7053",
    "data-name": "Group 7053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7052",
    "data-name": "Group 7052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7051",
    "data-name": "Group 7051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7050",
    "data-name": "Group 7050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17133",
    "data-name": "Path 17133",
    d: "M0,0H26.071V29.659H0Z",
    transform: "translate(29.659) rotate(90)",
    fill: "#00acb1"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7056",
    "data-name": "Group 7056",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17134",
    "data-name": "Path 17134",
    d: "M171.068,227.466h3.783v3.783A1.05,1.05,0,0,0,175.9,232.3h5.693a1.05,1.05,0,0,0,1.049-1.049v-3.783h3.783a1.05,1.05,0,0,0,1.049-1.05v-5.693a1.05,1.05,0,0,0-1.049-1.049h-3.783V215.89a1.05,1.05,0,0,0-1.049-1.049H175.9a1.05,1.05,0,0,0-1.049,1.049v3.783h-3.783a1.05,1.05,0,0,0-1.049,1.049v5.693A1.05,1.05,0,0,0,171.068,227.466Zm1.05-5.693H175.9a1.05,1.05,0,0,0,1.049-1.049V216.94h3.595v3.783a1.05,1.05,0,0,0,1.049,1.049h3.783v3.594h-3.783a1.05,1.05,0,0,0-1.049,1.049V230.2h-3.595v-3.783a1.05,1.05,0,0,0-1.049-1.049h-3.783Z",
    transform: "translate(-152.176 -196.331)",
    fill: "#005963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17135",
    "data-name": "Path 17135",
    d: "M49.338,38.471H4.4a4.4,4.4,0,0,0-4.4,4.4V79.726a4.4,4.4,0,0,0,4.4,4.4H49.338a4.4,4.4,0,0,0,4.4-4.4V42.874A4.4,4.4,0,0,0,49.338,38.471ZM2.1,42.874a2.3,2.3,0,0,1,2.3-2.3H49.338a2.3,2.3,0,0,1,2.3,2.3V47.29H2.1ZM51.635,79.726a2.3,2.3,0,0,1-2.3,2.3H4.4a2.3,2.3,0,0,1-2.3-2.3V49.389H51.635Z",
    transform: "translate(0 -38.471)",
    fill: "#005963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17136",
    "data-name": "Path 17136",
    d: "M59.644,80.486H58.206a1.049,1.049,0,1,0,0,2.1h1.437a1.049,1.049,0,0,0,0-2.1Z",
    transform: "translate(-51.158 -76.077)",
    fill: "#005963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17137",
    "data-name": "Path 17137",
    d: "M121.693,80.486h-1.437a1.049,1.049,0,1,0,0,2.1h1.437a1.049,1.049,0,1,0,0-2.1Z",
    transform: "translate(-106.695 -76.077)",
    fill: "#005963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17138",
    "data-name": "Path 17138",
    d: "M183.741,80.486H182.3a1.049,1.049,0,0,0,0,2.1h1.437a1.049,1.049,0,1,0,0-2.1Z",
    transform: "translate(-162.232 -76.077)",
    fill: "#005963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17139",
    "data-name": "Path 17139",
    d: "M281.944,80.486H263.892a1.049,1.049,0,1,0,0,2.1h18.051a1.049,1.049,0,1,0,0-2.1Z",
    transform: "translate(-235.258 -76.077)",
    fill: "#005963"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.981db60973b3834f531829e2943f60fa.svg";
export { ForwardRef as ReactComponent };